var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-menu"},[_vm._t("activator",null,{"on":_vm.activator}),_c('transition-bounce',[_c('b2b-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],ref:"card",staticClass:"b2b-menu__content",style:({
        marginLeft: '-190px',
        top: '85px'
      }),attrs:{"width":"256","maxWidth":"246px"}},[_vm._t("default")],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }